<div class="modal-header" translate>Item already exists</div>
<div
  class="modal-body"
  translate="The {isDir, select, true {directory} false {file} other {item} } “{ name }” already exists"
  [translateParams]="{ isDir: options.existingFile.isDir, name: options.pasteFile.name }"
></div>
<div class="modal-footer">
  <checkbox class="me-auto" [(ngModel)]="options.applyToAll" text="Apply to all" />
  <button
    class="btn btn-outline-danger"
    (click)="doOverwrite()"
    data-test-qa="doOverwrite"
    [ngbTooltip]="'Merge directories and overwrite conflicting files' | translate"
    translate
  >
    Overwrite
  </button>
  <button
    class="btn btn-outline-warning"
    (click)="doRename()"
    data-test-qa="doRename"
    [ngbTooltip]="'Append timestamp' | translate"
    translate
  >
    Rename
  </button>
  <button class="btn btn-outline-secondary" (click)="doSkip()" data-test-qa="doSkip" translate>
    Skip
  </button>
</div>
